export default class UnreadNotificationCenter {
  constructor(config = {}) {
    this.containerSelector = config.containerSelector;
    this.modalSelector = config.modalSelector;
    this.listSelector = config.listSelector;
    this.loaderSelector = config.loaderSelector;
    this.emptySelector = config.emptySelector;
    this.totalSelector = config.totalSelector;
    this.markAllSelector = config.markAllSelector;
    this.onError = config.onError || function() {};

    this.container = document.querySelector(this.containerSelector);
    if (!this.container) {
      return;
    }

    this.badgeElement = this.container.querySelector('.js-unread-count');
    this.triggerElements = this.container.querySelectorAll('.js-unread-trigger');

    this.modalElement = document.querySelector(this.modalSelector);
    this.listElement = document.querySelector(this.listSelector);
    this.loaderElement = document.querySelector(this.loaderSelector);
    this.emptyElement = document.querySelector(this.emptySelector);
    this.totalElement = document.querySelector(this.totalSelector);
    this.markAllButton = document.querySelector(this.markAllSelector);

    this.countUrl = this.container.dataset.countUrl;
    this.itemsUrl = this.container.dataset.itemsUrl;
    this.markUrl = this.container.dataset.markUrl;
    this.markTaskUrl = this.container.dataset.markTaskUrl;
    this.markAllUrl = this.container.dataset.markAllUrl;
    this.initialCount = parseInt(this.container.dataset.initialCount || '0', 10) || 0;

    this.bindEvents();
    this.updateCount(this.initialCount);
    this.fetchCount();
  }

  bindEvents() {
    this.triggerElements.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        this.loadItems();
      });
    });

    if (this.markAllButton) {
      this.markAllButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.markAll();
      });
    }

    if (this.listElement) {
      this.listElement.addEventListener('click', (event) => {
        const target = event.target.closest('.js-notification-link');
        if (!target) {
          return;
        }
        event.preventDefault();
        const itemType = target.dataset.itemType;
        const itemId = target.dataset.itemId;
        const redirectUrl = target.getAttribute('href');

        this.markItem(itemType, itemId)
          .always(() => {
            window.location.href = redirectUrl;
          });
      });
    }
  }

  fetchCount() {
    if (!this.countUrl) {
      return;
    }

    $.ajax({
      url: this.countUrl,
      type: 'GET'
    }).done((response) => {
      if (response && typeof response.total_unread === 'number') {
        this.updateCount(response.total_unread);
      }
    }).fail(() => {
      this.onError('Erreur lors de la récupération des notifications.');
    });
  }

  loadItems() {
    if (!this.itemsUrl || !this.listElement) {
      return;
    }

    this.setLoadingState(true);

    $.ajax({
      url: this.itemsUrl,
      type: 'GET'
    }).done((response) => {
      const items = (response && response.items) || [];
      this.renderItems(items);
      if (response && typeof response.total_unread === 'number') {
        this.updateCount(response.total_unread);
      }
    }).fail((jqXHR, textStatus) => {
      if (textStatus === 'abort' || (jqXHR && (jqXHR.status === 0 || jqXHR.statusText === 'abort'))) {
        return;
      }
      this.onError('Erreur lors du chargement des commentaires.');
    }).always(() => {
      this.setLoadingState(false);
    });
  }

  renderItems(items) {
    if (!this.listElement) {
      return;
    }

    this.listElement.innerHTML = '';
    this.listElement.classList.toggle('d-none', items.length === 0);

    if (!items.length) {
      if (this.emptyElement) {
        this.emptyElement.classList.remove('d-none');
      }
      return;
    }

    if (this.emptyElement) {
      this.emptyElement.classList.add('d-none');
    }
    this.listElement.classList.remove('d-none');

    items.forEach((item) => {
      const listItem = document.createElement('li');
      listItem.className = 'list-group-item py-3';

      const wrapper = document.createElement('div');
      wrapper.className = 'd-flex justify-content-between align-items-start flex-wrap';

      const content = document.createElement('div');
      content.className = 'flex-grow-1 pr-3';

      const title = document.createElement('h6');
      title.className = 'mb-1 d-flex align-items-center';

      const typeBadge = document.createElement('span');
      typeBadge.className = 'badge badge-light text-uppercase mr-2';
      typeBadge.textContent = item.object_type === 'Order' ? 'Commande' : (item.object_type === 'StudyRequest' ? "Demande d'étude" : 'Tâche');
      title.appendChild(typeBadge);

      const serviceNumber = document.createElement('span');
      serviceNumber.className = 'font-weight-bold';
      serviceNumber.textContent = item.service_number || '--';
      title.appendChild(serviceNumber);

      content.appendChild(title);

      if (item.message) {
        const message = document.createElement('p');
        message.className = 'mb-1 text-muted';
        message.textContent = item.message;
        content.appendChild(message);
      }

      const meta = document.createElement('small');
      meta.className = 'text-muted';
      meta.textContent = item.created_at_hr || '';
      content.appendChild(meta);

      wrapper.appendChild(content);

      if (item.link) {
        const actions = document.createElement('div');
        actions.className = 'text-right mt-2 mt-md-0';

        const link = document.createElement('a');
        link.className = 'btn btn-sm btn-primary js-notification-link';
        link.href = item.link;
        link.dataset.itemType = item.type;
        link.dataset.itemId = item.id;
        link.textContent = 'Ouvrir';

        actions.appendChild(link);
        wrapper.appendChild(actions);
      }

      listItem.appendChild(wrapper);
      this.listElement.appendChild(listItem);
    });
  }

  markItem(itemType, itemId) {
    if (!this.markUrl) {
      return $.Deferred().resolve();
    }

    return $.ajax({
      url: this.markUrl,
      type: 'POST',
      data: {
        item_type: itemType,
        item_id: itemId
      }
    }).done((response) => {
      if (response && typeof response.total_unread === 'number') {
        this.updateCount(response.total_unread);
        this.loadItems();
      }
    }).fail(() => {
      this.onError('Impossible de mettre à jour la notification.');
    });
  }

  markAll() {
    if (!this.markAllUrl) {
      return;
    }

    this.setLoadingState(true);

    $.ajax({
      url: this.markAllUrl,
      type: 'POST'
    }).done((response) => {
      if (response && typeof response.total_unread === 'number') {
        this.updateCount(response.total_unread);
      } else {
        this.updateCount(0);
      }
      this.renderItems([]);
    }).fail(() => {
      this.onError('Impossible de marquer toutes les notifications comme lues.');
    }).always(() => {
      this.setLoadingState(false);
    });
  }

  setLoadingState(isLoading) {
    if (this.loaderElement) {
      this.loaderElement.classList.toggle('d-none', !isLoading);
    }
    if (this.listElement) {
      this.listElement.classList.toggle('d-none', isLoading);
    }
  }

  updateCount(count) {
    const safeCount = count || 0;

    if (this.badgeElement) {
      if (safeCount > 0) {
        this.badgeElement.classList.remove('d-none');
        this.badgeElement.textContent = safeCount;
      } else {
        this.badgeElement.classList.add('d-none');
        this.badgeElement.textContent = 0;
      }
    }

    if (this.totalElement) {
      this.totalElement.textContent = safeCount;
    }
  }
}
